export default __webpack_public_path__ + "static/media/asset-coupon.cc729ec2.svg";